import React, { useState, useRef, useEffect } from "react";
import clsx from "clsx";
import styles from "./STSelect.module.css";
import { Icons } from "@/const/icons";

export const STSelect = ({
  label,
  placeholder = "Select option",
  options = [],
  required = false,
  fullWidth = false,
  className,
  variant = "dark", // dark | light
  value,
  onChange,
  error,
}) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(value || "");
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (value !== undefined) {
      setSelected(value);
    }
  }, [value]);

  const selectedLabel =
    options.find((o) => o.value === selected)?.label || placeholder;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={clsx(
        styles.wrapper,
        styles[variant],
        fullWidth && styles.fullWidth,
        error && styles.error,
        className,
      )}
    >
      {label && (
        <label className={styles.label}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}

      {/* Trigger */}
      <div
        className={clsx(
          styles.selectBox,
          open && styles.open,
        )}
        onClick={() => setOpen((v) => !v)}
      >
        <span
          className={clsx(
            styles.value,
            !selected && styles.placeholder,
          )}
        >
          {selectedLabel}
        </span>

        <span className={clsx(styles.arrow, open && styles.rotate)}>
          {Icons.iconChevronDown}
        </span>
      </div>

      {/* Dropdown */}
      {open && (
        <ul className={clsx(styles.menu,"position-absolute start-0 end-0 radius-xs")}>
          {options.map((opt) => (
            <li
              key={opt.value}
              className={clsx(
                styles.option,
                selected === opt.value && styles.activeOption,
              )}
              onClick={() => {
                setSelected(opt.value);
                setOpen(false);
                if (onChange) onChange(opt.value);
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
      {error && <p className={clsx(styles.errorText)}>{error}</p>}
    </div>
  );
};
